<template lang="pug">
  SspLayout(area="core")
    template(slot="actions")
      button.btn.btn-primary(@click="toggleFilter") {{this.showFilter ? 'Hide' : 'Show'}} Filter
      button.btn.btn-default(@click="clearFilter") Clear Filter
      button.btn.btn-default(@click="$refs.grid.reload()")
        i.fa.fa-refresh
      SspActionButton.btn.btn-default(@onClick="initExportData" :disabled="!dataToDownload" icon="download" text="" buttonType="default" :spinning="downloading" :title="exportButtonTitle")

    .row.validation-filter(v-show="showFilter")
      .col-sm-12
        .panel.panel-default
          .panel-heading.panel-title Configure Validation Filter
          .panel-body
            .form-horizontal
              .form-group
                label.col-sm-2 Validation Result:
                .col-sm-1
                  input(type="checkbox" v-model="filter.hideValid")
                  label.pl5 Valid
                .col-sm-1
                  input(type="checkbox" v-model="filter.hideVerified")
                  label.pl5 Verified
                .col-sm-1
                  input(type="checkbox" v-model="filter.hideInvalid")
                  label.pl5 Invalid
                .col-sm-2
                  input(type="radio" v-model="filter.batch" :value="false")
                  label.pl5.pr10 Proxy
                  input(type="radio" v-model="filter.batch" :value="true")
                  label.pl5 Batch

                label.col-sm-2.control-label Number of Validations
                .col-sm-2
                  select.form-control(v-model="additionalFilter.relation")
                    option(v-for="vr in validationRelations" :value="vr.value") {{vr.label}}

                .col-sm-1
                  input.form-control(type="number" v-model="additionalFilter.count")

            hr
            .form-horizontal
              .form-group
                label.col-sm-2 Time Range:
                label.col-sm-1 From
                .col-sm-2
                  Datepicker(v-model="additionalFilter.occurredAfter" :timePicker="true")
                label.col-sm-1 To
                .col-sm-2
                  Datepicker(v-model="additionalFilter.occurredBefore" :timePicker="true")

            hr
            .form-horizontal
              .form-group
                label.col-sm-2 Kezzlercodes
                .col-sm-10
                  input.form-control(v-model="additionalFilter.codes" placeholder="Codes ...")
              .form-group
                label.col-sm-2 Status
                .col-sm-10
                  .parent
                    .child(v-for="s in statuses" :title="s.value")
                      input(type="checkbox" v-model="filter.errorCodes" :value="s.value")
                      label.ml5.unbold {{s.label}}

              .form-group
                label.col-sm-2 Organization
                .col-sm-4
                  OrganizationSelect(v-model="additionalFilter.organizationId")
                label.col-sm-2 Product
                .col-sm-4
                  ProductSelect(ref="productSelect" v-model="additionalFilter.productId")

              .form-group
                label.col-sm-2 Order IDs
                .col-sm-4
                  input.form-control(v-model="additionalFilter.orders" type="text" placeholder="Order IDs")
                label.col-sm-2 Section IDs
                .col-sm-4
                  input.form-control(v-model="additionalFilter.sections" type="text" placeholder="Section IDs")

            hr
            .form-horizontal
              .form-group
                label.col-sm-2 IP/Phone
                .col-sm-4
                  input.form-control(v-model="additionalFilter.phoneNumbers" type="text" placeholder="Phonenumbers")
                label.col-sm-2 Entry Channel
                .col-sm-4
                  EntrychannelSelect(ref="entryChannelSelect" v-model="additionalFilter.entryChannelId")
            div(v-if="this.filter.batch")
              hr
              .form-horizontal
                .form-group
                  label.col-sm-2 User IDs
                  .col-sm-4
                    input.form-control(v-model="additionalFilter.users" type="text")
                  label.col-sm-2 Batch IDs
                  .col-sm-4
                    input.form-control(v-model="additionalFilter.batches")

          .panel-footer
            .text-right
              button.btn.btn-primary(@click="$refs.grid.reload()") Filter
              button.btn.btn-default.ml10(@click="clearFilter") Clear Filter

    DataGrid.validation-log(ref="grid" :fetch="fetchData" @error="$emit('error', $event)" url-page-param="page")
      tr(slot="thead")
        th Status
        th Organization
        th Code
        th Product
        th {{ filter.batch ? 'User' : 'Channel' }}
        th(v-if="!filter.batch") IP/Phone
        th Time
        th Order & Section
        th Validations
        th
      tr(v-for="vl in validationLog" :class="{'valid': vl.valid === 'true', 'invalid': vl.valid === 'false', 'verified': vl.valid === 'verified'}")
        td.bold
          span(v-if="vl.valid==='true'") Valid
          span(v-if="vl.valid==='false'") Invalid
          span(v-if="vl.valid==='verified'") Verified
        td
          span.hover(v-if="vl.organization" @click="appendOrganizationToFilter(vl.organization.id)") {{vl.organization.value}}
        td.hover.kzcode-default(@click="appendCodeToFilter(vl.code)") {{vl.code}}
        td
          span.hover(v-if="vl.product" @click="appendProductToFilter(vl.product)") {{vl.product.name}}
        td
          span(v-if="vl.channel")
            em.text-muted(v-if="!filter.batch && vl.channel.value === 'Unknown'") No Channel
            span(v-if="!filter.batch && vl.channel.id > 0")
              i.fa.pr5(:class="{'fa-globe': vl.channel.type === 'web', 'fa-phone': vl.channel.type === 'sms'}")
              span.hover(@click="appendEntryChannelToFilter(vl.channel)") {{vl.channel | entryChannel}}
            span(v-else-if="filter.batch") {{vl.user.value}}
        td(v-if="!filter.batch" style="width: 180px;")
          span.hover(@click="appendEntryToFilter(vl.entry)") {{vl.entry}}
          span(v-if="vl.location")
            a.ml5.fa.fa-map-marker.marker(v-if="vl.location.coords" :href="`//www.google.com/maps/place/${vl.location.coords.lat},${vl.location.coords.long}`")
            span.label.label-info.ml5(v-if="vl.location.country") {{vl.location.country}}
        td {{vl.occurred | date}}
        td
          span.hover(v-if="vl.orderId" @click="appendOrderToFilter(vl.orderId)") {{vl.orderId}}
            span.hover(@click="appendSectionToFilter(vl.sectionId)") , {{vl.sectionId}}
        td {{vl.validations}}
        td.actions
          a.fa.fa-comments(@click="$refs.validationMessageModal.open(vl.responseMessage)" title="Validation Response")
          a(v-if="vl.valid === 'verified'" @click="$refs.verifiedReasonModal.open(vl.errorCode, vl.errorMessage)" :title="vl.errorMessage") {{vl.errorCode}}

    ValidationMessageModal(ref="validationMessageModal")
    VerifiedReasonModal(ref="verifiedReasonModal")
</template>

<script>
import Datepicker from '@/components/common/Datepicker'
import OrganizationSelect from '@/components/ssp/OrganizationSelect'
import ProductSelect from '@/components/ssp/ProductSelect'
import EntrychannelSelect from '@/components/ssp/EntrychannelSelect'
import Core from '@/service/apis/Core'
import DataGrid from '@/components/ssp/DataGrid'
import Util from '@/service/Util'
import { dateFilter, entryChannelvalue, numberFilter } from '@/filters/filters'
import ValidationMessageModal from './ValidationMessageModal'
import VerifiedReasonModal from './VerifiedReasonModal'

export default {
  data: () => ({
    validationRelations: [{
      label: 'At least',
      value: 'AT_LEAST'
    }, {
      label: 'Exactly',
      value: 'EXACTLY'
    }, {
      label: 'At most',
      value: 'AT_MOST'
    }],
    statuses: [{
      label: 'Internal error',
      value: 0
    }, {
      label: 'Code owner is not on channel',
      value: 101
    }, {
      label: 'This code is blacklisted',
      value: 102
    }, {
      label: 'Section not yet enabled',
      value: 103
    }, {
      label: 'Section is not yet active',
      value: 104
    }, {
      label: 'Section has been deactivated',
      value: 105
    }, {
      label: 'Administrative code',
      value: 106
    }, {
      label: 'Code has status that denies validation',
      value: 108
    }, {
      label: 'Exceeded defined validation limit',
      value: 109
    }, {
      label: 'The code has been recalled',
      value: 110
    }, {
      label: 'The code was validated in the wrong geographical location',
      value: 120
    }, {
      label: 'The code does not represent a sellable product',
      value: 130
    }, {
      label: 'The code belongs to another organization',
      value: 140
    }, {
      label: 'The product can not be validated on the channel',
      value: 150
    }],
    showFilter: false,
    validationLog: [],
    filter: {},
    additionalFilter: {},
    totalRecords: null,
    downloading: false
  }),
  created() {
    this.filter = this.minimumFilterData()
    this.additionalFilter = this.additionalFilterData()
  },
  methods: {
    minimumFilterData() {
      return {
        errorCodes: [],
        hideInvalid: true,
        hideValid: true,
        hideVerified: true,
        batch: false
      }
    },
    additionalFilterData() {
      return {
        occurredAfter: null,
        occurredBefore: null,
        organizationId: null,
        productId: null,
        orders: null,
        sections: null,
        entryChannelId: null,
        phoneNumbers: null,
        codes: null,
        users: null,
        batches: null,
        count: null,
        relation: 'AT_LEAST'
      }
    },
    clearFilter() {
      this.filter = this.minimumFilterData()
      this.additionalFilter = this.additionalFilterData()
      this.$refs.grid.reload()
    },
    fetchData(page) {
      this.validationLog = []
      const BY_NEWLINE_OR_COMMA = /[\n\r\s,]+/
      const req = {
        max: page.maxOffsetRequest().max,
        offset: page.maxOffsetRequest().offset,
        hideInvalid: !this.filter.hideInvalid,
        hideValid: !this.filter.hideValid,
        hideVerified: !this.filter.hideVerified,
        validationType: this.filter.batch ? 'SUPERVISED' : 'NORMAL',
        occurredAfter: this.additionalFilter.occurredAfter,
        occurredBefore: this.additionalFilter.occurredBefore,
        codes: {
          code: this.additionalFilter.codes ? Util.sanitizeCodes(this.additionalFilter.codes) : null
        },
        validationCount: {
          count: this.additionalFilter.count,
          relation: this.additionalFilter.relation
        },
        errorCodes: {
          code: this.filter.errorCodes
        },
        organizationId: this.additionalFilter.organizationId ? this.additionalFilter.organizationId : null,
        productIds: {
          productId: this.additionalFilter.productId ? [this.additionalFilter.productId] : null
        },
        orderIds: {
          orderId: this.additionalFilter.orders ? this.additionalFilter.orders.split(BY_NEWLINE_OR_COMMA) : null
        },
        sectionIds: {
          sectionId: this.additionalFilter.sections ? this.additionalFilter.sections.split(BY_NEWLINE_OR_COMMA) : null
        },
        phoneNumbers: {
          phoneNumber: this.additionalFilter.phoneNumbers ? this.additionalFilter.phoneNumbers.split(BY_NEWLINE_OR_COMMA) : null
        },
        channelIds: {
          channelId: this.additionalFilter.entryChannelId ? [this.additionalFilter.entryChannelId] : null
        },
        userIds: {
          userId: this.additionalFilter.users ? this.additionalFilter.users.split(BY_NEWLINE_OR_COMMA) : null
        },
        batchIds: {
          batchId: this.additionalFilter.batches ? this.additionalFilter.batches.split(BY_NEWLINE_OR_COMMA) : null
        }
      }
      this.downloadReq = req

      return Core.getAllValidations(req)
        .then((resp) => {
          resp.data.entryElement.forEach((element) => {
            const em = element
            if (em.errorCode) {
              const foundErrorMessage = this.statuses.find((s) => s.value === em.errorCode)
              if (foundErrorMessage) {
                em.errorMessage = foundErrorMessage.label
              } else {
                em.errorMessage = 'Unknown verified reason'
              }
            }
            this.validationLog.push(em)
          })
          this.totalRecords = numberFilter(resp.data.totalRecords)
          return resp.data.totalRecords
        })
        .catch((e) => {
          this.$emit('error', e)
        })
    },
    toggleFilter() {
      this.showFilter = !this.showFilter
    },
    appendEntryChannelToFilter(val) {
      const name = val.value.split('=')
      const value = {
        id: val.id,
        name: name[1]
      }
      this.additionalFilter.entryChannelId = val.id
      this.$refs.entryChannelSelect.setSelectedEntrychannel(value)
      this.$refs.grid.reload()
    },
    appendSectionToFilter(val) {
      this.additionalFilter.sections = `${val}`
      this.$refs.grid.reload()
    },
    appendOrderToFilter(val) {
      this.additionalFilter.orders = `${val}`
      this.$refs.grid.reload()
    },
    appendEntryToFilter(val) {
      this.additionalFilter.phoneNumbers = val
      this.$refs.grid.reload()
    },
    appendOrganizationToFilter(organizationId) {
      this.additionalFilter.organizationId = organizationId
      this.$refs.grid.reload()
    },
    appendProductToFilter(val) {
      this.additionalFilter.productId = val.productId
      this.$refs.productSelect.setSelectedProduct(val)
      this.$refs.grid.reload()
    },
    appendCodeToFilter(val) {
      this.additionalFilter.codes = val
      this.$refs.grid.reload()
    },
    initExportData() {
      this.downloading = true
      this.$confirm({ text: `Are you sure you want to download ${this.totalRecords} records?` })
        .then((conf) => {
          if (conf) {
            const req = Object.assign(this.downloadReq, { max: 20000 })

            const onDone = (allRecords) => {
              this.performExport(allRecords)
              this.downloading = false
            }

            this.fetchExportData(0, req, [], onDone)
              .catch((e) => {
                this.$emit('error', e)
              })
          } else {
            this.downloading = false
          }
        })
    },
    fetchExportData(offset, req, buffer, doneCallback) {
      return Core.getAllValidations(req)
        .then((resp) => {
          let request = req
          const mappedRecords = this.prepareValidationRecords(resp.data.entryElement)
          buffer.push(...mappedRecords)
          if (resp.data.hasMore === true) {
            const increasedOffset = offset + request.max
            request = Object.assign(request, { offset: increasedOffset })
            return this.fetchExportData(increasedOffset, request, buffer, doneCallback)
          }
          doneCallback(buffer)
          return buffer
        })
    },
    prepareValidationRecords(data) {
      const mappedRecords = data.map((v) => {
        const channel = v.channel.value.split('=')
        const minValidation = {
          code: v.code,
          valid: v.valid,
          validations: v.validations,
          entry: v.entry,
          channel: channel[1],
          product: v.product ? v.product.name : null,
          orderId: v.orderId,
          sectionId: v.sectionId,
          organization: v.organization.value,
          occurred: dateFilter(v.occurred, 'YYYY-MM-DD HH:mm:ss'),
          errorCode: v.errorCode ? v.errorCode : null
        }

        Object.keys(minValidation)
          .forEach((key) => {
            if (minValidation[key] === null) {
              minValidation[key] = ''
            }
          })
        return minValidation
      })
      return mappedRecords
    },
    performExport(data) {
      const exportHeaders = {
        code: 'Code',
        valid: 'Valid',
        validations: 'Validations',
        entry: 'Entry',
        channel: 'Channel',
        product: 'Product',
        orderId: 'Order ID',
        sectionId: 'Section ID',
        organization: 'Organization',
        occurred: `Timestamp - ${Util.timezone()}`,
        errorCode: 'Error Code'
      }
      let dataString = this.createCsvRowFromObject(exportHeaders)

      data.forEach((v) => {
        dataString += this.createCsvRowFromObject(v)
      })

      const downloadReq = {
        filename: 'export-data.csv',
        type: 'text/csv',
        data: dataString
      }

      Util.initiateBlobDownload(downloadReq)
    },
    createCsvRowFromObject(obj) {
      const rowElements = []
      Object.keys(obj)
        .forEach((key) => {
          let val = String(obj[key])
          if (val.includes(',')) {
            val = `"${val}"`
          }
          rowElements.push(val)
        })
      const rowString = rowElements.join(',')
      return `${rowString}\n`
    }
  },
  computed: {
    dataToDownload() {
      return this.validationLog && this.validationLog.length > 0
    },
    exportButtonTitle() {
      return `Download ${this.totalRecords} records`
    }
  },
  components: {
    Datepicker,
    OrganizationSelect,
    ProductSelect,
    EntrychannelSelect,
    DataGrid,
    ValidationMessageModal,
    VerifiedReasonModal
  },
  filters: {
    date: dateFilter,
    entryChannel: entryChannelvalue
  }
}
</script>

<style lang="scss">
.validation-filter {
  .parent {
    display: flex;
    flex-wrap: wrap;
  }
  .child {
    display: inline-block;
    width: calc(100% * (1/2))
  }
}
.validation-log {
  p, span, td {
    color: black;
  }
  .valid, .valid:hover {
    background-color: rgba(165, 255, 165, 0.4) !important;
  }

  .invalid, .invalid:hover {
    background-color: rgba(255, 110, 110, 0.2) !important;
  }

  .verified, .verified:hover {
    background-color: rgba(255, 255, 110, 0.3) !important;
  }

  .hover {
    cursor: pointer;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pages/core/validation/validationlog/ValidationLog.vue